import React from 'react';
import './App.css';
import Experience from './Experience.component';
import Link from './Link.component';

const devExperiences = [
  <Experience 
    title={"Configurateur 3D"} 
    client={<Link url='https://www.makemepulse.com/'>makemepulse</Link>} 
    description={"Développement d'une expérience de configuration de la Fisker Ocean, ainsi que son intégration dans un site web et une application mobile."} 
    features={[
        <>Target : <Link url={"https://www.fiskerinc.com/fr-fr/configure/ocean"}>Web</Link> / <Link url={"https://play.google.com/store/apps/details?id=com.fisker.fiskerapp"}>Android</Link> / <Link url={"https://apps.apple.com/us/app/fisker-flexee/id1486002675"}>iOS</Link></>,
        <>Intégration d'AR pour placer la voiture devant soi</>,
        <>Interface partagée par les trois plateformes, qui s'adapte suivant le type d'input et la taille de l'écran</>,
        <>Optimisation graphique pour l'export Web</>,
        <>Features Unity : Unity Forma, URP, UIToolkit, Unity MARS, animation de modèles 3D</>,
        <>Autres outils : Github, Zenhub, Figma, méthode agile</>,
      ]
    }
    images={[
      require("./img/MakeMePulse1.gif"),
      require("./img/MakeMePulse2.gif"),
    ]}
  />,
  <Experience 
    title={"Jeux VR"} 
    client={<><Link url='https://albyon.io/'>Albyon</Link> & <Link url='https://atlasv.io/'>Atlas V</Link></>} 
    description={"Développement de jeux de combat en VR."} 
    features={[
        <>Target : certains projets pour Meta Quest 2 / d'autres projets pour tous les casques VR</>,
        <>Suivi des mains</>,
        <>Gestion de contrôleurs universels pour fonctionner sur tous les casques</>,
        <>Intégration de succès Quest</>,
        <>Optimisation des performances pour un jeu avec un environnement destructible</>,
        <>Features Unity : Unity XR, Oculus Intregration Kit, URP, Timeline, NavMesh</>,
        <>Autres outils : Github, Perforce, Jira, Coda, méthode agile, anglais (équipe internationale)</>,
      ]
    }
    images={[
      require("./img/Albyon2.gif"),
      require("./img/Albyon1.gif"),
    ]}
  />,
  <Experience 
    title={"Applications métier"} 
    client={<Link url='https://www.acoem.com/france/fr/'>ACOEM</Link>} 
    description={"Développement d'applications métier dans le secteur industriel."} 
    features={[
        <>Target : Android / iOS</>,
        <>Connexion à un capteur externe en bluetooth</>,
        <>Utilisations de webservices (authentification utilisateur, historique d'utilisation, etc.)</>,
        <>Intégration de Mapbox et du GPS pour visualisation la position sur une carte</>,
        <>Intégration d'AR pour placer le capteur sur la machine en maintenance</>,
        <>Reconnaissance d'images en AR pour afficher un menu contextuel</>,
        <>Features Unity : AR Foundation, Mapbox, Placenote, UIToolkit</>,
        <>Autres outils : Sourcetree, BitBucket, Jira, méthode agile</>,
      ]
    }
    images={[
      require("./img/ACOEM2.gif"),
      require("./img/ACOEM3.gif"),
      require("./img/ACOEM1.gif"),
    ]}
  />,
  <Experience 
    title={"Recherche artistique VR"} 
    client={"Diorama"}
    description={"Développement d'expériences sensorielles innovantes."} 
    features={[
        <>Target : Web</>,
        <>Création d'un nouveau type de visite virtuelle de musée</>,
        <>Optimisation pour un déploiement en WebXR</>,
        <>Features Unity : Unity XR, ShaderGraph, VFXGraph</>,
        <>Autres outils : Github, Trello, Airtable, méthode agile</>,
      ]
    }
    images={[
      require("./img/Diorama1.gif"),
      require("./img/Diorama3.gif"),
      require("./img/Diorama2.gif"),
    ]}
  />,
  <Experience 
    title={"Applications innovantes"} 
    client={<Link url='http://www.360g.fr/'>360G</Link>}
    description={"Développement d'applications interactives basées sur le suivi de mouvements."} 
    features={[
        <>Target : PC</>,
        <>Création d'expériences variées : mini-jeux de footbal, essayage d'habits
        augmenté, expériences artistiques libres</>,
        <>Utilisation d'un capteur de profondeur, ainsi que d'une webcam</>,
        <>Suivi des gestes et reconnaissance des émotions en temps réel</>,
        <>Création du produit <Link url='http://www.360g.fr/miro.html'>Miro</Link> (hardware et software)</>,
        <>Installations dans plusieurs boutiques OL et dans le salon ELounge du Groupama Stadium</>,
        <>Features Unity : Skeleton tracking, animation de personnages 3D, ShaderGraph, VFXGraph</>,
        <>Autres outils : Github, Trello, méthode agile</>,
      ]
    }
    images={[
      require("./img/360G1.gif"),
      require("./img/360G2.gif"),
    ]}
  />,
  <Experience 
    title={"Recherche scientifique"} 
    client={<Link url='https://github.com/Nico04/Pore-Aventura'>Pore Aventura</Link>}
    description={"Développement d'une application open source de visualisation de données scientifiques."} 
    features={[
        <>Export PC</>,
        <>Optimisation des performances pour permettre de visualiser plusieurs millions d'élements simultanément</>,
        <>A reçu un <Link url='https://iusti.cnrs.fr/2021/02/18/test-titre/?doing_wp_cron=1671556778.0867869853973388671875'>prix</Link> grâce à <Link url='https://youtu.be/NkHmAcAheAQ'>cette vidéo</Link></>,
        <>Features Unity : VFXGraph</>,
        <>Autres outils : Github</>,
      ]
    }
    images={[
      require("./img/PoreAventura1.gif"),
      require("./img/PoreAventura2.gif"),
    ]}
  />,
];

const TrainExperiences = [
  <Experience 
    title={"Préparations aux certifications"} 
    client={<Link url='https://www.f3df.com/'>F3DF</Link>}
    description={"Formations pour passer les certifications Unity auprès d'un centre certifié partenaire officiel d'Unity."} 
    features={[
        <>Préparations aux certifications <Link url={"https://www.f3df.com/store/formations-modelisation-3d/design-realite-virtuelle-augmentee/unity-gameplay-programmer/"}>Programmer</Link> et <Link url={"https://www.f3df.com/store/formations-modelisation-3d/design-realite-virtuelle-augmentee/unity-3d-artist/"}>Artist</Link></>,
        <>J'ai moi-même passé la certification Programmer, afin de pouvoir être formateur</>,
      ]
    }
    images={[
      require("./img/F3DF1.png"),
    ]}
  />,
  <Experience 
    title={"Formations sur mesure"} 
    client={<Link url='https://www.softeaminstitute.fr/'>Softeam Institude</Link>}
    description={"Formations à destination des entreprises, adaptées à des besoins spécifiques."} 
    features={[
      <>Prise en main d'Unity</>,
      <>Initiation au C# </>,
      <>Présentation des fonctionnalités avancées (Timeline, Cinemachine, UNet / Netcode for Unity, etc.)</>,
      <>Création d'app pour Hololens</>,
      ]
    }
    images={[
      require("./img/Softeam1.gif"),
    ]}
  />,
  <Experience 
    title={"Cursus scolaire"} 
    client={"Gaming Campus, Ynov, ICAN, ESGI"} 
    description={"Module de formation s'inscrivant dans un cursus Game Programming."} 
    features={[
        <>Présentation d'Unity</>,
        <>Introduction des design patterns</>,
        <>Optimisation et bonnes pratiques</>,
        <>Problématiques spécifiques à l'AR et la VR</>,
        <>Pédagogie par projet : création d'un jeu en groupe</>,
      ]
    }
    images={[
      require("./img/Ecoles1.png"),
      require("./img/Ecoles2.png"),
      require("./img/Ecoles3.png"),
      require("./img/Ecoles4.png"),
    ]}
  />,
];

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Portfolio de Léo Forner</h1>
          <hr />

          <h2 style={{textTransform:'uppercase'}}>Développeur Unity</h2>

          {devExperiences.map((experience, index) => 
            <div key={"experience" + index}>{experience}</div>
          )}
          
          <h2 style={{textTransform:'uppercase'}}>Formateur Unity</h2>

          {TrainExperiences.map((experience, index) => 
            <div key={"experience" + index}>{experience}</div>
          )}
      </header>
    </div>
  );
}

export default App;
